import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { Check, HourglassEmpty, Sync } from '@material-ui/icons';
import BotaoDefault from '../../../../../../../components/Botoes/BotaoDefault';
import {
  Container,
  Header,
  Body,
  Aureola,
  Titulo,
  Detalhe,
  Passos,
  Passo,
  Marcador,
  Resumo,
  Linha,
  Chips,
  Chip,
} from './styles';

export type FaseExecucao = 'enfileirada' | 'executando' | 'finalizada';

interface ModalProgressoProps {
  aberto: boolean;
  fase: FaseExecucao;
  entidades: string[];
  total: boolean;
  desde: string;
  /** Alguma consulta pegou a conta com sincronizando = true. */
  observadaEmExecucao: boolean;
  onFechar: () => void;
}

const FASES: FaseExecucao[] = ['enfileirada', 'executando', 'finalizada'];

const PASSOS: Record<FaseExecucao, string> = {
  enfileirada: 'Na fila',
  executando: 'Sincronizando',
  finalizada: 'Finalizada',
};

const TITULOS: Record<FaseExecucao, string> = {
  enfileirada: 'Aguardando na fila',
  executando: 'Sincronizando',
  finalizada: 'Sincronização finalizada',
};

const ModalProgresso: React.FC<ModalProgressoProps> = ({
  aberto,
  fase,
  entidades,
  total,
  desde,
  observadaEmExecucao,
  onFechar,
}) => {
  const indiceAtual = FASES.indexOf(fase);
  const concluida = fase === 'finalizada';

  const detalhe = () => {
    if (fase === 'enfileirada') {
      return 'A sincronização foi enfileirada e começa assim que a fila processar.';
    }

    if (fase === 'executando') {
      return total
        ? 'Em execução. Ao concluir, o checkpoint da sincronização automática será avançado.'
        : 'Em execução. O checkpoint da sincronização automática será mantido.';
    }

    // Execução curta pode começar e terminar entre duas consultas; nesse caso não
    // afirmamos que rodou, porque a fila também pode estar parada.
    return observadaEmExecucao
      ? 'A conta não está mais sincronizando.'
      : 'A conta não está sincronizando. Foi rápido demais para ser acompanhado por aqui — confira os logs se precisar de certeza.';
  };

  const icone = () => {
    if (concluida) return <Check />;

    return fase === 'enfileirada' ? <HourglassEmpty /> : <Sync />;
  };

  return (
    <Container onClose={onFechar} open={aberto}>
      <Header>
        <h1>Sincronização</h1>
        <BotaoDefault onClick={onFechar} title="Fechar">
          <CloseIcon />
        </BotaoDefault>
      </Header>

      <Body>
        <Aureola concluida={concluida}>{icone()}</Aureola>

        <Titulo concluida={concluida}>{TITULOS[fase]}</Titulo>
        <Detalhe>{detalhe()}</Detalhe>

        <Passos>
          {FASES.map((passo, indice) => {
            let estado: 'pendente' | 'atual' | 'concluido' = 'pendente';

            if (indice < indiceAtual) estado = 'concluido';
            if (indice === indiceAtual)
              estado = concluida ? 'concluido' : 'atual';

            return (
              <Passo key={passo} estado={estado} primeiro={indice === 0}>
                <Marcador />
                <span>{PASSOS[passo]}</span>
              </Passo>
            );
          })}
        </Passos>

        <Resumo>
          <Linha>
            <small>Tipo</small>
            <strong>
              {total
                ? 'Total — avança o checkpoint automático'
                : 'Parcial — mantém o checkpoint automático'}
            </strong>
          </Linha>

          <Linha>
            <small>A partir de</small>
            <strong>{desde}</strong>
          </Linha>

          <Linha>
            <small>Entidades ({entidades.length})</small>
            <Chips>
              {entidades.map(entidade => (
                <Chip key={entidade}>{entidade}</Chip>
              ))}
            </Chips>
          </Linha>
        </Resumo>
      </Body>
    </Container>
  );
};

export default ModalProgresso;
